<template>
  <div class="mx-auto mt-10 pb-12 relative resume-container-h">
    <div class="flex flex-wrap mb-10">
      <div class="width-49percent">
        <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.start') }}</label>
        <label class="custom-color-neutral text-zt-lg">{{ state.request.fechaDesde }}</label>
      </div>
      <div class="width-49percent with-marginleft">
        <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.return') }}</label>
        <label class="custom-color-neutral text-zt-lg">{{ state.request.fechaReingreso }}</label>
      </div>
    </div>
    <div class="custom-color-neutral mb-10"
         v-if="state.request.documents.length > 0">
      <label class="text-zt-base flex mb-1">
        {{ $t('message.documentComponent.details.documentTitle') }}:
      </label>
      <div class="flex items-center border rounded border-gray-500 p-2">
        <zt-icon name="document-pdf" class="text-icon-custom mr-3" />
        <span v-if="state.request.documents.length > 1">
          {{
            $t('message.documentComponent.details.documentCountPlural', {
              length: state.request.documents.length
            })
          }}
        </span>
        <span v-else>
          {{
            $t('message.documentComponent.details.documentCount', {
              length: state.request.documents.length
            })
          }}
        </span>
      </div>
    </div>
    <div class="mb-10">
      <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.approver') }}</label>
      <label class="custom-color-neutral text-zt-lg">{{ aprobadorSeleccionado.data  | toCapitalize }}</label>
      <!-- <zt-input v-model="aprobadorSeleccionado.data" outlined color="white" :label="$t('message.licenseComponent.licenseBox.approver')" disabled="true" /> -->
    </div>
    <div v-if="state.request.periodoLiq" class="mb-10">
      <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.liqPeriod') }}</label>
      <label class="custom-color-neutral text-zt-lg font-bold">{{ state.request.periodoLiq | parseLiq }}</label>
    </div>
    <div class="mb-10" v-if="state.request.anticipatePayment">
      <label class="custom-color-neutral text-zt-lg">{{ $t('message.dashboard.salaryAdvance.requested') }}</label>
    </div>
    <div v-if="state.request.observaciones">
      <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.commentLabel') }}</label>
      <v-textarea
        solo
        outline
        color="#fff"
        readonly
        :value="state.request.observaciones"
        data-vs-textarea="observations"
      ></v-textarea>
    </div>
    <div v-if="state.request.francos.length > 0" class="mb-10">
      <label class="custom-color-neutral text-zt-base flex">{{ $t('message.licenseComponent.licenseBox.francos') }}</label>
      <zt-chip
        v-for="(franco, index) in state.request.francos"
        :key="index"
        outline
        class="bg-chip w-1/2 md:w-1/3"
        data-vs-chip="francosChip"
      >
        {{ franco }}
      </zt-chip>
    </div>
    <div class="z-20 absolute bottom-0 right-0 left-0">
      <div class="mx-auto w-full">
        <zt-button text @click="stepBackward" :disabled="requestButtonDisabled" class="w-5/12 ml-2 text-button-color" data-vs-button="stepBackward">
          {{ $t('message.licenseComponent.licenseBox.back') }}
        </zt-button>
        <template>
          <zt-button @click="requestLicense" :disabled="requestButtonDisabled" class="w-5/12 float-right mr-2" data-vs-button="requestLicence">
            {{ $t('message.licenseComponent.licenseBox.requestLicense') }}
          </zt-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RequestProcessResume',
  inject: ['state', 'mutations'],
  props: {
    aprobadorSeleccionado: {
      default: '',
      type: Object
    },
    requestButtonDisabled: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {

    }
  },
  methods: {
    stepBackward(){
      this.$emit('step-backward');
    },
    requestLicense(){
      this.$emit('request-license');
    },
  },
  filters: {
    parseLiq(value){
      return moment(value, 'YYYY-MM').format("MM/YYYY");
    },
    toCapitalize(str) {
      if(str) {
        return str.toLowerCase().split(' ')
          .map((word) => {
            return word
              .split('')
              .map((char, index) => {
                if (index === 0) return char.toUpperCase();
                return char;
              })
              .join('');
          }).join(' ');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.width-49percent{
  width: 49%;
}
.with-marginleft{
  margin-left: 2%;
}
.zt-input-outlined {
  border-color: white !important;
}
.bg-chip {
  background-color: white !important;
}
.width-chip {
  width: 47%
}
::v-deep .v-text-field--outline {
  .v-input__slot {
    border: 2px solid rgba(255, 255, 255, 0.87) !important;
  }
  textarea {
    color: #707070 !important;
  }
}
@media screen and (max-width: 1023px) {//Mobile
  .resume-container-h {
    //min-height: calc(100vh - 206px);
    min-height: 61vh;
  }
}
@media screen and (min-width: 1024px) { //Desktop
  .resume-container-h {
    min-height: 24.5rem;
  }
}
.zt-button-disabled {
  background-color: #959595 !important;
  color: white !important;
}
.zt-button-disabled-outline {
  background-color: #959595 !important;
  color: white !important;
}

.text-icon-custom {
  font-size: 2.266rem;
}
</style>
